import { useIsAggregatedAirline } from "../../../hooks/useIsAggregatedAirline";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { MultiSeriesDiscountedBookingsLoader } from "./MultiSeriesDiscountedBookingsLoader";
import { SingleSeriesDiscountedBookingsLoader } from "./SingleSeriesDiscountedBookingsLoader";

export type DiscountedBookingsChartLoaderProps = {
  from: Date;
  to: Date;
};

export const DiscountedBookingsChartLoader = ({ from, to }: DiscountedBookingsChartLoaderProps) => {
  const isAggregatedAirline = useIsAggregatedAirline();
  const { selectedAirlineCodes } = useSelectedAirline({ useSuspense: true });

  if (isAggregatedAirline && selectedAirlineCodes.length > 1) {
    return <MultiSeriesDiscountedBookingsLoader from={from} to={to} />;
  }

  return <SingleSeriesDiscountedBookingsLoader from={from} to={to} />;
};
